import React from 'react';
import { observer } from 'mobx-react';
import Loader from 'react-simple-loading';
import ConversationItem from './ConversationItem';

import { RootStoreContext } from '../../../../../context';

import './OpenChats.css';

@observer
class OpenChats extends React.Component {

  static contextType = RootStoreContext;

  render () {
    const {
      privateMessagingStore: {
        openChatsList,
        memberCombinedOpenChatsList,
        conversations: { loading }
      },
      loggedInUser
    } = this.context;
    return (
      <div id="anchor-opened-conversations">
        {loading && (
          <div style={{ paddingTop: '10px' }}>
            <Loader size="20px" stroke="2px" />
          </div>
        )}
        {
          !loading &&
          (
            (loggedInUser.account.anchor && openChatsList.length === 0) ||
            (!loggedInUser.account.anchor && memberCombinedOpenChatsList.length === 0)
          ) && (
          <p className="no-opened-conversations">No opened chats</p>
        )}
        {loggedInUser.account.anchor && openChatsList.length > 0 && (
          <ul className="opened-chats">
            {openChatsList.map(openChat => (
              <ConversationItem
                key={openChat.name}
                openChat={openChat}
              />)
            )}
          </ul>
        )}
        {!loggedInUser.account.anchor && memberCombinedOpenChatsList.length > 0 && (
          <ul className="opened-chats">
            {memberCombinedOpenChatsList.map(openChat => (
              <ConversationItem
                key={openChat.name}
                openChat={openChat}
              />)
            )}
          </ul>
        )}
      </div>
    );
  }
}

export default OpenChats;